import React, { useState } from "react";
import { Calendar } from "ui/components/calendar";
import { Button } from "ui/components/button";
import { Popover, PopoverContent, PopoverTrigger } from "ui/components/popover";
import { CalendarIcon, ChevronLeft, ChevronRight } from "lucide-react";
import { format, startOfWeek, endOfWeek, addWeeks, subWeeks } from "date-fns";
import { cn } from "ui/lib/utils";

const WeekPicker = ({ currentDate, onWeekChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  
  // Calculate current week boundaries
  const weekStart = startOfWeek(currentDate, { weekStartsOn: 1 }); // Monday start
  const weekEnd = endOfWeek(currentDate, { weekStartsOn: 1 });
  
  // Format week display
  const formatWeekDisplay = () => {
    const startMonth = format(weekStart, "MMM");
    const endMonth = format(weekEnd, "MMM");
    const startDay = format(weekStart, "d");
    const endDay = format(weekEnd, "d");
    const year = format(weekStart, "yyyy");
    
    if (startMonth === endMonth) {
      return `${startMonth} ${startDay}-${endDay}, ${year}`;
    } else {
      return `${startMonth} ${startDay} - ${endMonth} ${endDay}, ${year}`;
    }
  };

  const handleDateSelect = (date) => {
    if (date) {
      onWeekChange(date);
      setIsOpen(false);
    }
  };

  const handlePreviousWeek = () => {
    const previousWeek = subWeeks(currentDate, 1);
    onWeekChange(previousWeek);
  };

  const handleNextWeek = () => {
    const nextWeek = addWeeks(currentDate, 1);
    onWeekChange(nextWeek);
  };

  return (
    <div className="flex items-center gap-2">
      <Button
        variant="outline"
        size="sm"
        onClick={handlePreviousWeek}
        className="h-8 w-8 p-0"
      >
        <ChevronLeft className="h-4 w-4" />
      </Button>
      
      <Popover open={isOpen} onOpenChange={setIsOpen}>
        <PopoverTrigger asChild>
          <Button
            variant="outline"
            className={cn(
              "min-w-[200px] justify-start text-left font-normal",
              !currentDate && "text-muted-foreground"
            )}
          >
            <CalendarIcon className="mr-2 h-4 w-4" />
            {formatWeekDisplay()}
          </Button>
        </PopoverTrigger>
        {/* <PopoverContent className="w-auto p-0" align="start">
          <Calendar
            mode="single"
            selected={currentDate}
            onSelect={handleDateSelect}
            initialFocus
            modifiers={{
              weekRange: (date) => {
                const dateWeekStart = startOfWeek(date, { weekStartsOn: 1 });
                const currentWeekStart = startOfWeek(currentDate, { weekStartsOn: 1 });
                return dateWeekStart.getTime() === currentWeekStart.getTime();
              }
            }}
            modifiersStyles={{
              weekRange: {
                backgroundColor: "hsl(var(--accent))",
                color: "hsl(var(--accent-foreground))"
              }
            }}
          />
        </PopoverContent> */}
      </Popover>
      
      <Button
        variant="outline"
        size="sm"
        onClick={handleNextWeek}
        className="h-8 w-8 p-0"
      >
        <ChevronRight className="h-4 w-4" />
      </Button>
    </div>
  );
};

export default WeekPicker;
